import "@/styles/globals.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { AppProps } from "next/app";
import { Toaster } from "react-hot-toast";
import { createTheme, ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

// Create a clienttest
const queryClient = new QueryClient();

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      light: "#DD6043",
      main: "#DD6043",
      dark: "#DD6043",
      contrastText: "#fff",
    },
    secondary: {
      light: "#DD6043",
      main: "#f44336",
      dark: "#DD6043",
      contrastText: "#000",
    },
  },
});

export default function App({ Component, pageProps }: AppProps) {
  return (
    <>
      <Toaster position="top-right" />
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            {/* <ReactQueryProvider> */}
            <Component {...pageProps} />
            {/* </ReactQueryProvider> */}
          </LocalizationProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </>
  );
}
